import type { BaseTranslation } from '../i18n-types';

// Don't export this in base translation,
// breaks in typesafe-i18n with Typescript 5+ when regenerating
const translationValues: BaseTranslation = {
    SHEETS: 'Sheets',
    DASHBOARDS: 'Dashboards',
    DATABASE_TABLE: 'Database table',
    VARIABLES: 'Variables',
    FILES: 'Files',
    APPS: 'Apps',
    LABEL: 'Label',
    EDIT_TYPE: 'Edit type',
    EDITING_ROW: 'Editing row {label}',
    CREATE_NEW_ROW: 'Create new row',
    ADD: 'Add',
    MULTIPLY: 'Multiply',
    SET: 'Set',
    PERCENT_CHANGE: 'Percent change',
    NAME: 'Name',
    NAME_AND_STYLE: 'Name & style',
    PATH: 'Path',
    SHARE_WITH: 'Share with',
    SUBMIT: 'Submit',
    EDIT: 'Edit',
    ANY: 'Any',
    VIEW: 'View',
    EDITING: 'Edit',
    DUPLICATE: 'Duplicate',
    DUPLICATE_SHEET_LOADING: 'Duplicating sheet...',
    DUPLICATE_SHEET_SUCCESS: 'Successfully duplicated sheet',
    DUPLICATE_SHEET_ERROR: 'Error while duplicating sheet',
    DUPLICATE_FOLDER_LOADING: 'Duplicating folder...',
    DUPLICATE_FOLDER_SUCCESS: 'Successfully duplicated folder',
    DUPLICATE_FOLDER_ERROR: 'Error while duplicating folder',
    DELETE_TILE: 'Delete tile',
    MATCH_CASE: 'Match case',
    SEARCH: 'Search',
    SEARCH_VALUES: 'Search values',
    IMPORT: 'Import',
    MODEL_HEALTH: 'Model health',
    CHECKLIST: 'Checklist',
    DYNAMIC_ANALYSIS: 'Dynamic analysis',
    STATIC_ANALYSIS: 'Static analysis',
    CALCULATION_LOGS: 'Calculation logs',
    ERROR_MESSAGE: 'Error message',
    CALCULATION_TIME_MS: 'Calculation time (ms)',
    ERRORS: 'Errors',
    WARNINGS: 'Warnings',
    AMPLIFICATION_FACTOR: 'Amplification factor',
    CELL_COUNT_ESTIMATE: 'Cell count (estimate)',
    NO_CALCULATION_ERRORS: 'No calculation errors',
    CALCULATION_ERRORS: 'Calculation errors found',
    NO_MODELLING_ERRORS: 'No modelling errors',
    MODELLING_ERRORS: 'Modelling errors found',
    MODEL_FULLY_LOADED: 'Model fully loaded',
    MODEL_NOT_LOADED: 'Model not loaded',
    SHARING: 'Sharing',
    ASSIGNMENT: 'Assignment',
    ASSIGNMENTS: 'Assignments',
    LOAD_MORE: 'Load more',
    SHARES: 'Shares',
    SHARE: 'Share',
    OPEN: 'Open',
    NONE: 'None',
    TABLE: 'Table',
    VALUE: 'Value',
    DATE: 'Date',
    NONE_SELECTED: 'None selected',
    VALUE_FOR_MONTH: 'Value for month',
    DESCRIPTION: 'Description',
    NOTES: 'Notes',
    CUSTOM_FIELD: 'Custom field',
    TABLE_DESCRIPTION: 'Table description',
    EDIT_COLUMN: 'Edit column',
    COLUMN_TYPE: 'Column type',
    MONTH: 'Month',
    VARIABLE_AND_DIMENSIONS: 'Variable & dimensions',
    SHOW_UNMAPPED: 'Select unmapped items only',
    MANUAL_MAPPING: 'Manual mapping',
    CLEAR: 'Clear',
    AUTODETECT: 'Autodetect',
    FILTER: 'Filter',
    SELECT_ALL_BRACKETS: '(Select all)',
    BLANK_CELLS_BRACKETS: '(Blank cells)',
    SELECT_DIMENSIONS: 'Select dimensions',
    CONFIRM: 'Confirm',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Are you sure you want to remove all mappings?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'This action will remove all manually added mapping tags.',
    ERROR_IMPORTING_FILE: 'Error when importing file',
    CHOOSE_JOB_TO_REPLACE: 'Choose job to replace',
    PREVIOUS_IMPORTS: 'Previous imports',
    WELCOME_TO_IMPORT: 'Welcome to import.',
    IMPORT_SPREADSHEETS: 'Import your spreadsheets from Excel right into Farseer and manage them.',
    DRAG_FILE_HERE: 'Drag your file here',
    BROWSE: 'Browse',
    IMPORT_MISSING_MEMBERS: 'Import missing members',
    IMPORT_VALUES: 'Import values',
    NO_COLUMN_SET_AS_TABLE: 'No column set as dimension table',
    NO_COLUMN_SET_AS_VALUE: 'No column set as value',
    MISSING_MEMBERS: 'There are missing dimension members',
    SELECT_ALL: 'Select all',
    DESCRIPTION_COLUMN: 'Description column',
    CONNECTED_DIMENSIONS_COLUMN: 'Connected dimensions column',
    CANCEL: 'Cancel',
    CONTINUE: 'Continue',
    CREATE_DIMENSIONS: 'Create dimensions',
    SELECT_CONNECTION: 'Select connection',
    CLOSE: 'Close',
    SAVE: 'Save',
    DELETE: 'Delete',
    REMOVE: 'Remove',
    DELETING_ASSIGNMENT: 'Deleting the assignment{multiple} ...',
    DELETED_ASSIGNMENT: 'The assignment{multiple} deleted!',
    FAILED_DELETE_ASSIGNMENT: 'Failed to delete the assignment{multiple}',
    DELETE_ASSIGNMENT: 'Delete the assignment{multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Do you want to delete the selected assignment{multiple}?',
    COLUMNS: 'Columns',
    FORMATTING: 'Formatting',
    PRESERVE_FORMATTING: 'Preserve formatting',
    CUSTOM_FORMATTING: 'Custom formatting',
    GROUP_OUTLIERS: 'Group outliers',
    VERSIONS: 'Versions',
    NONE_VERSION: 'None',
    APPLY_TO_ALL_YEARS: 'Apply to all years',
    SHEET_OPTIONS: 'Sheet options',
    DASHBOARD_OPTIONS: 'Dashboard options',
    LOCK_GRID: 'Lock grid',
    RESPONSIVE_LAYOUT: 'Responsive layout',
    AUTO_REFRESH_DASHBOARD: 'Auto-refresh dashboard',
    REFRESH_DASHBOARD: 'Refresh dashboard',
    ONLY_WITH_DATA: 'Only with data',
    OWD_INCLUDE_MEASURES: 'Include measures',
    SHOW_NO_RESULT_ROWS: 'Show "No Result" rows',
    STACKED: 'Stacked',
    TIMELINE: 'Timeline',
    RESET_COLUMN_ORDER: 'Reset column order',
    STANDARD_COLUMNS_NAME: 'Name',
    STANDARD_COLUMNS_DESCRIPTION: 'Description',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Name + Description',
    DOWNLOADING_FILE: 'Downloading file',
    FILE_DOWNLOADED: 'File downloaded',
    FAIL_FILE_DOWNLOAD: 'Failed to export from given configuration',
    ADD_TO_DASHBOARD: 'Add to dashboard',
    COPY_TO_DASHBOARD: 'Copy to dashboard',
    SUBMIT_ENTRIES_CONFIRMATION: 'Are you sure you want to submit your entries?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT:
        "You won't be able to make any further changes after submitting and the link will be locked.",
    LINK_NOT_FOUND: 'Link not found.',
    LINK_EXPIRED: 'This link has expired.',
    DEPLOYMENT: 'Deployment',
    UNKNOWN: 'Unknown',
    FILE_SIZE_10GB: 'File size > 10GB',
    FILE_SIZE_64MB: 'File size > 64MB',
    FILE_SIZE_1MB: 'File size > 1MB',
    FILE_SIZE_TOO_LARGE: 'File size too large',
    LINK_URL_PLACEHOLDER: 'Paste a link and press Enter',
    LINK_URL_INVALID: 'Links must start with https://, http:// or #/',
    UPLOADED: 'Uploaded',
    ERROR_UPLOADING_FILE: 'Error uploading file',
    FOLDER_NAME: 'Folder name',
    NEW_DIMENSION_TABLE: 'New dimension table',
    NEW_VARIABLE: 'New variable',
    NEW_DASHBOARD: 'New dashboard',
    NEW_SHEET: 'New sheet',
    UPLOAD_FILE: 'Upload file',
    NEW_FOLDER: 'New folder',
    NEW_REMOTE_JOB: 'New app',
    DOWNLOAD: 'Download',
    DELETE_MENU_ITEM_CONFIRM: 'Are you sure you want to delete {menuItem}?',
    USER_REMOVED: 'User has been removed!',
    FAILED_USER_REMOVE: 'Failed to remove user',
    USER_DELETING: 'Deleting user {fullName}',
    USER_DELETING_CONFIRM: 'Are you sure you want to delete user {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Confirm delete operation',
    DELETE_YEAR_CONFIRMATION: 'Are you sure you want to delete the year {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Are you sure you want to delete {name} version?',
    YEARS: 'Years',
    YEAR: 'Year',
    ADD_YEAR: 'Add {year}',
    OPTIONS: 'Options',
    NO_VERSION_SELECTED: 'No version selected',
    INTERVAL_START_GREATER: 'Start of interval greater than some of the interval ends',
    INTERVAL_END_GREATER: 'End of interval lesser than some of the interval starts',
    INTERVAL_START_GREATED_END: 'Start of interval greater than the end',
    NO_NAME_INPUT: 'Assignment must have a name',
    EDIT_ASSIGNMENTS: 'Edit assignments',
    ASSIGNMENT_NAME: 'Assignment name',
    VERSION: 'Version',
    ADD_VERSION: 'Add version',
    ADD_NEW_VERSION: 'Add new version',
    NEW_VERSION_NAME: 'New version name',
    ERROR_ADDING_VERSION: 'Error adding version.',
    NAME_AND_COLOR: 'Name & color',
    ADDED_BY: 'Added by',
    CREATE_SERVICE_USER: 'Create service user',
    CREATE_USER: 'Create user',
    USER_TYPE: 'User type',
    STANDARD: 'Standard',
    SERVICE: 'Service',
    CREATED_SERVICE_USER: 'Service user created',
    FAILED_CREATE_SERVICE_USER: 'Failed to create service user and API key',
    SERVICE_USER_NAME_REQUIRED: 'Service user name is required',
    CREATED_USER: 'User created',
    FAILED_CREATE_USER: 'Failed to create user',
    LAST_NAME_REQUIRED: 'Last name is required',
    FIRST_NAME_REQUIRED: 'First name is required',
    EMAIL_REQUIRED: 'Email required',
    PASSWORD_REQUIRED: 'Password required',
    PASSWORD_INCORRECT: 'Password incorrect',
    FIRST_NAME: 'First name',
    LAST_NAME: 'Last name',
    EMAIL: 'Email',
    PASSWORD: 'Password',
    CONFIRM_PASSWORD: 'Confirm password',
    API_KEY: 'API key',
    CREATED_SERVICE_USER_API_KEY: 'Service user {serviceUserName} API key created',
    API_KEY_COPIED_TO_CLIPBOARD: 'API key copied to clipboard',
    MANAGE_API_KEYS: 'Manage API keys',
    API_KEYS_FOR_USER: 'API keys – {name}',
    API_KEYS_SHOWN_ONCE: 'Keys are shown only once, when they are created.',
    API_KEYS_ROTATE_HINT: 'To rotate a key, create a new one, update your integration, then delete the old key.',
    API_KEYS_EMPTY: 'This user has no API keys.',
    CREATE_API_KEY: 'Create API key',
    EDIT_API_KEY: 'Edit API key',
    API_KEY_UPDATED: 'API key updated',
    CREATE_SERVICE_USER_API_KEY: 'Create an API key',
    API_KEY_CREATED: 'API key created',
    API_KEY_COPY_NOW: "Copy the key now. It won't be shown again.",
    API_KEY_UNTITLED: 'Untitled key',
    API_KEY_DESCRIPTION_PLACEHOLDER: 'e.g. SAP export – prod',
    API_KEY_CREATED_AT: 'Created',
    API_KEY_CREATED_BY: 'Created by',
    API_KEY_EXPIRES: 'Expires',
    API_KEY_EXPIRY: 'Expiry',
    API_KEY_EXPIRY_IN_PAST: 'The expiry must be in the future',
    API_KEY_NEVER_EXPIRES: 'Never',
    API_KEY_EXPIRES_IN_DAYS: 'in {days:number} {{day|days}}',
    API_KEY_EXPIRES_TODAY: 'Expires today',
    API_KEY_EXPIRED_ON: 'Expired {date}',
    API_KEY_MANAGED_BY_OVERSEER: 'Managed by Overseer',
    API_KEY_MANAGED_BY_OVERSEER_HINT: "Rotated by Farseer support. It can't be edited or deleted here.",
    API_KEY_DELETE_QUESTION: 'Delete API key "{name}"? Integrations using it stop working immediately.',
    API_KEY_DELETED: 'API key deleted',
    CONNECT: 'Connect',
    DISCONNECT: 'Disconnect',
    MIXED_VERSIONS: 'Mixed versions',
    MIXED: 'Mixed',
    USE_RESTRICTIONS: 'Restrict entry to versions and intervals',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Allow entry on Property columns',
    PROPERTY_COLUMNS: 'Property columns',
    USE_TIME_LIMIT: 'Use time limit',
    SELECT_VERSION: 'Select a version',
    EXPIRES_AFTER: 'Expires after',
    CHANGE: 'Change',
    SMART_FILTER_CHANGE: 'Change',
    CHANGES_SUBMITTED: 'Changes submitted. Awaiting review.',
    SUBMITTED: 'Submitted',
    ASSIGNMENTS_AVAILABLE: 'assignments available',
    SUBMITTING_ASSIGNMENT: 'Submitting the assignment.',
    SUBMITED_ASSIGNMENT: 'The assignment is submitted.',
    FAIL_SUBMIT_ASSIGNMENT: 'Failed to submit the assignment.',
    ASSIGNMENT_LABEL_CREATED: 'Label created and added to assignment',
    SUBMIT_CHANGES: 'Submit changes?',
    SUBMIT_CHANGES_CONFIRMATION:
        "Are you sure you want to submit your changes? You won't be able to make any further edits, the process will be marked as Ready for Review and the owner of this sheet will be notified.",
    CANT_UNDONE_ACTION: 'This action cannot be undone.',
    APP_LANGUAGE: 'App language',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: "Target version can't be same as source version.",
    TARGET_VERSION: 'Target version',
    SELECT_TARGET_VERSION: 'Please select target version.',
    SOURCE_VERSION: 'Source version',
    SELECT_SOURCE_VERSION: 'Please select source version.',
    ROW_TAGS: 'Row tags',
    DELETE_THIS_ROW: 'Delete this row',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Select parent tag to generate multiple rows',
    GLOBAL_SEARCH_PLACEHOLDER: 'Search sheets, dashboards, database tables, apps and variables',
    NO_RESULTS_FOUND: 'No results found.',
    NEW_TILE: 'New tile',
    SLICER_STATE_SAVED: 'Slicer state saved for everyone!',
    INVALID_LINK: 'Invalid link',
    LINK_NOT_EXIST: 'Link does not exist.',
    ACCESS_NOT_GRANTED: 'Access not granted to host.',
    CONTACT_ADMIN: 'Please contact your administrator for more information.',
    LOGOUT: 'Logout',
    REGENERATING_LINKS: 'Regenerating links...',
    REGENERATED: 'Regenerated!',
    FAILED_REGENERATING_LINKS: 'Failed to regenerate links for selected public assignments.',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Regenerate links for selected assignments?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION:
        'Are you sure you want to regenerate links for selected assignments? The old links will be invalid. This action cannot be undone.',
    REGENERATE: 'Regenerate',
    REGENERATE_LINK: 'Regenerate link',
    SHEET_NOT_FOUND: 'Sheet not found',
    CLUSTER_NOT_FOUND: 'Cluster not found',
    PARENT_CLUSTER_NOT_FOUND: 'Parent cluster not found',
    TAG_NOT_FOUND: 'Tag not found',
    SHEET_ID_NOT_FOUND: 'Sheet id not found',
    FAIL_CREATE_ROW: 'Failed creating row',
    FAIL_CREATE_CLUSTER: 'Failed creating cluster',
    ROW_CREATED: 'Row created',
    COLUMN_CREATED: 'Column created',
    DIMENSION_CREATED: 'Dimension created',
    NOT_IMPLEMENTED_YET: 'Not implemented yet',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Variable field should contain variables only',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Unknown zone in single value',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Filter field should contain dimension tags',
    UNKNOWN_ZONE_DATA_EDITOR: 'Unknown zone in data editor',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Variable field should contain account tags',
    CUSTOM_COLUMN_NOT_FOUND: 'Custom column not found',
    CANT_ADD_TO_COLUMN: "Can't add {tagType} to column type {columnType}",
    TAG_ALREADY_ADDED: 'This tag is already added',
    MODEL_IMPORT_IN_PROGRESS: 'Model import in progress...',
    MODEL_IMPORT_SUCCESS: 'Model imported successfully.',
    CODE_EDITOR_ALLOW_CHANGES: 'Allow the code editor to make changes to the model:',
    ALLOW_ALL: 'Allow all',
    DELETE_MEMBER_ROWS: 'Delete rows',
    DELETE_TABLES: 'Delete tables',
    DELETE_VARIABLES: 'Delete variables',
    DELETE_COLUMNS: 'Delete columns',
    DELETE_EVERYTHING: 'Delete everything when applying changes',
    DRY_RUN: 'Dry run',
    MODEL_CODE_EDITOR: 'Model code editor',
    MODEL_IMPORT_EXPORT: 'Model import/export',
    MODEL_IMPORT: 'Model import',
    MODEL_EXPORT: 'Model export',
    MODEL_USE_IN_EXPORT: 'Use in export',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Dimension tables',
        DMEM: 'Dimension members',
        VAR: 'Variables',
        CELL: 'Cells',
    },
    LOADING: 'Loading...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Analyzing your question',
    CHAT_STATS_ACTIONS: '{count:number} {{action|actions}}',
    CHAT_STATS_CONTEXT: '{tokens:string} context',
    CHAT_STATS_DURATION_TOOLTIP: 'How long this answer took to generate',
    CHAT_STATS_ACTIONS_TOOLTIP: 'How many actions the agent performed (loading skills, running code)',
    CHAT_STATS_CONTEXT_TOOLTIP:
        'Current size of the conversation context. Older turns get summarized once it grows too large.',
    CHAT_DEFAULT_TITLE: 'Chat',
    CHAT_ENTER_FULLSCREEN: 'Enter fullscreen',
    CHAT_EXIT_FULLSCREEN: 'Exit fullscreen',
    CHAT_RENAME: 'Rename chat',
    CHAT_DELETE: 'Delete chat',
    CHAT_CREATE_NEW: 'Create new chat',
    CHAT_MESSAGE_PLACEHOLDER: 'Message FarseerAI...',
    CHAT_SEND: 'Send',
    CHAT_RENAME_TITLE: 'Rename chat',
    CHAT_HELP_QUESTION: 'What can I help you with today',
    CHAT_SUGGESTED: 'Suggested',
    CHAT_GENERATING_SUGGESTIONS: 'Tailoring suggestions to your model…',
    CHAT_SUGGESTED_SUMMARY: 'Summarize this model and its key drivers',
    CHAT_SUGGESTED_VARIANCE: "What's the biggest variance between actuals and plan this year, and why?",
    CHAT_SUGGESTED_DRIVERS: "Break down what's driving my results this quarter",
    CHAT_SUGGESTED_DASHBOARD: 'Build an executive overview dashboard for this model',
    CHAT_SUGGESTED_PNL_DASHBOARD: 'Create a P&L dashboard comparing actuals vs plan',
    CHAT_SUGGESTED_APPS: 'What can I run from here? Show my available apps',
    CHAT_SUGGESTED_RANKING: 'Show me my top and bottom performers this year',
    CHAT_CREATED: 'Chat created!',
    CHAT_CREATED_NEW: 'New chat created!',
    CHAT_RENAMED: 'Chat renamed!',
    CHAT_DELETED: 'Chat deleted!',
    CHAT_FAILED_CREATE: 'Failed to create a new chat.',
    CHAT_FAILED_LOAD: 'Failed to load chats.',
    CHAT_FAILED_RENAME: 'Failed to rename the chat.',
    CHAT_FAILED_DELETE: 'Failed to delete a chat.',
    CHAT_FAILED_CANCEL: 'Failed to cancel the request.',
    CHAT_FEEDBACK_FAILED: 'Failed to save feedback.',
    CHAT_FEEDBACK_THUMBS_UP: 'Good response',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Bad response',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Tell us what went wrong',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'What was helpful or what went wrong? (optional)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Save',
    CHAT_FEEDBACK_CLEAR: 'Clear feedback',
    CHAT_AGENT_TYPE_ANALYST: 'Analyst',
    ADVANCED_SETTINGS: 'Advanced settings',
    INVALID_JSON_ERROR: 'Invalid JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Maintenance mode is currently enabled',
    MAINTENANCE_MODE_ENABLED: 'Maintenance mode enabled',
    CONTACT_ADMIN_FOR_INFO: 'Please wait or contact your administrator for more information.',
    RETRY: 'Retry',
    OTHER_WORKSPACES_AVAILABLE: 'Switch to a workspace you can access:',
    COPY_LINK: 'Copy link',
    COPY_DATA_FROM: 'Copy data from',
    ROWS_CUT: 'Rows cut',
    ROWS_COPIED: 'Rows copied',
    ROWS_MOVED: 'Rows moved',
    ROWS_PASTED: 'Rows pasted',
    CELLS_CUT: 'Cells cut',
    CELLS_COPIED: 'Cells copied',
    CELLS_COPIED_FROM: 'Cells copied from "{label}"',
    FAILED_CELLS_COPIED: 'Failed to copy cells {message}',
    CANNOT_CELLS_PASTED: 'Cannot paste cells here',
    NAMED_COPY: '{name} (copy)',
    TAG: 'Tag',
    ACTION: 'Action',
    MANAGE_CONNECTIONS_FOR: 'Manage connections for',
    RENAME: 'Rename',
    RENAME_FILE_EXTENSION_REQUIRED: 'File names need an extension, like .csv or .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Change file extension?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION:
        'This changes the extension from “.{oldExt}” to “.{newExt}”, which may change how the file is opened. Continue?',
    REMOVE_COLUMN: 'Remove column',
    REMOVE_CONNECTION: 'Remove connection',
    TABLE_CONNECTION: 'Table connection',
    TEXT: 'Text',
    TEXT_COLUMN: 'Text column',
    NUMBER: 'Number',
    NUMBER_COLUMN: 'Number column',
    NEW_NUMBER_COLUMN: 'New number column',
    FILE: 'File',
    FILE_COLUMN: 'File column',
    DATE_COLUMN: 'Date column',
    EDIT_TAG_TYPE: 'Edit {tagTypeName}',
    DELETE_TAG_TYPE: 'Delete {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Delete {tagTypeName} Data',
    CONNECTIONS: 'Connections',
    EDIT_CONNECTIONS: 'Edit connections',
    CLEAR_FIELD: 'Clear field',
    ERROR_CLEAR_FIELD: 'Error clearing field',
    REPLACE_FILE: 'Replace file',
    DOWNLOAD_FILE: 'Download file',
    DOWNLOAD_ORIGINAL_FILE: 'Download original file',
    FILE_DOES_NOT_EXIST: 'File does not exist',
    DELETE_FILE: 'Delete file',
    ERROR_DELETE_FILE: 'Error deleting file',
    LOCKS: 'Locks',
    YEARS_VERSIONS_MONTHS: 'Years / Versions / Months',
    CUSTOM_LOCK_RULES: 'Custom lock rules',
    STANDARD_LOCK_RULES: 'Standard lock rules',
    LOCK_RULES_WILL_BE_CONVERTED_TO_STANDARD:
        '{{1 lock rule|?? lock rules}} will be applied to the Years / Versions / Months table',
    LOCK_WILL_BE_CONVERTED_TO_STANDARD: 'This lock rule will be applied to the Years / Versions / Months table above',
    NO_CUSTOM_LOCKS_DEFINED: 'No custom lock rules defined',
    LOCK_REFERENCES_DELETED_ENTITIES: 'This lock references deleted entities',
    TABLE_SETTINGS: 'Table settings',
    NEW_MEMBER: 'New member',
    SORT_TABLE: 'Sort table',
    LOCK_TABLE: 'Lock table',
    UNLOCK_TABLE: 'Unlock table',
    TABLE_LOCKED_TOOLTIP: 'This table is locked',
    UNLOCK_SYSTEM_TABLE_TITLE: 'Unlock system table',
    UNLOCK_SYSTEM_TABLE_WARNING:
        'This is a system table. Unlocking it may affect model integrity. Are you sure you want to unlock it?',
    ERROR_LOCKING_TABLE: 'Error locking table.',
    ERROR_UNLOCKING_TABLE: 'Error unlocking table.',
    NAME_ASCENDING: 'Name ascending',
    NAME_DESCENDING: 'Name descending',
    ADD_SORT_RULE: 'Add sort rule',
    REMOVE_ALL_SORT_RULES: 'Remove all sort rules',
    '1_SORT': '1 sort',
    N_SORTS: '{count} sorts',
    DESCRIPTION_ASCENDING: 'Description ascending',
    DESCRIPTION_DESCENDING: 'Description descending',
    SORTING_DIMENSIONS: 'Sorting dimensions...',
    DIMENSIONS_SORTED: 'Dimensions sorted!',
    ERROR_SORTING_DIMENSIONS: 'Error sorting dimensions.',
    EDITING_TIMELINE_SLICER: 'Editing timeline slicer {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Create new timeline slicer',
    INTERVAL_START: 'Interval start',
    INTERVAL_END: 'Interval end',
    FORMAT: 'Format',
    OPERATION: 'Operation',
    MY_PROFILE_INFORMATION: 'My profile information',
    PROFILE_SETTINGS: 'Profile settings',
    ADD_PHOTO: 'Add photo',
    CHANGE_PHOTO: 'Change photo',
    UPDATE_PHOTO: 'Update photo',
    REMOVE_PHOTO: 'Remove photo',
    DECIMAL_SEPARATOR: 'Decimal separator',
    DATE_FORMAT: 'Date format',
    DATE_SEPARATOR: 'Date separator',
    ACCESSIBLE_CHART_PATTERNS: 'Accessibility patterns for charts',
    SET_AS_DEFAULT_PALETTE: 'Set as default palette',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Save current colors as a palette',
    DELETE_PALETTE: 'Delete palette',
    FILL_STYLE: 'Fill style',
    SOLID: 'Solid',
    HATCHED: 'Hatched',
    VARIABLE: 'Variable',
    DIMENSION: 'Dimension',
    CREATE_OR_GENERATE_NEW_ROWS: 'Create or generate new rows',
    CREATE_ROW_AS: 'Create {row} as',
    GENERATE_ROWS_FROM: 'Generate row(s) from',
    CREATE_NEW_VARIABLE: 'Create new variable',
    ENTER_FORMULA_FOR: 'Enter formula for {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Select a variable to view or edit its formula',
    DATABASE_AND_PROPERTIES: 'Database objects & properties',
    FOLDER_EMPTY: 'Folder empty',
    DASHBOARD_EMPTY: 'Dashboard empty',
    DASHBOARD_HINT: 'Get started with your dashboard by creating a tile.',
    YEARS_SETTINGS: 'Years settings',
    FINANCIAL_YEAR_STARTING_MONTH: 'Financial year starting month',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Updating financial year starting month',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Financial year starting month updated',
    SOMETHING_WENT_WRONG: 'Something went wrong.',
    SEARCH_FOR_USERS: 'Search for users...',
    SEARCH_FOR_GROUPS: 'Search for groups...',
    SEARCH_BY_GROUP_OR_USER: 'Search by group or user',
    USERS: 'Users',
    GROUPS: 'Groups',
    USER_OR_GROUP: 'User/Group',
    PERMISSIONS: 'Permissions',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'End date must be greater than start date',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'History data cannot overlap with forecast data',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Please choose an account tag',
    ERROR_STARTING_FORECAST: 'Error starting forecast',
    CUSTOM_FORECAST: 'Custom forecast',
    HISTORICAL_DATA_FROM: 'Historical data from',
    HISTORICAL_DATA_TO: 'Historical data to',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Source variable & dimensions',
    ERROR: 'Error {message}',
    FORECAST: 'Forecast',
    VIEW_FORECASTS_FOR_PERIOD: 'View forecasts for period',
    NO_JOBS_FOR_SELECTED_PERIOD: 'No jobs for selected period',
    ACTIVE_JOBS: 'Active jobs',
    FINISHED_JOBS: 'Finished jobs',
    COMPLETED_ON: 'Completed on {time}',
    FORECAST_PROGRESS: 'Forecast progress & history',
    ERROR_LOADING_FORECAST_JOBS: 'Error loading forecast jobs.',
    PAGE: 'Page',
    EDIT_ENTRY: 'Edit entry',
    NEW_ENTRY_BY_DATE: 'New entry by date',
    TAGS: 'Tags',
    ADD_TAG: 'Add tag',
    START_YEAR: 'Start year',
    START_MONTH: 'Start month',
    END_YEAR: 'End year',
    END_MONTH: 'End month',
    MUST_SELECT_ROW: 'You must select a row',
    TITLE: 'Title',
    SUBTITLE: 'Subtitle',
    FOOTNOTES: 'Footnotes',
    ROW: 'Row',
    SELECT_ROW: 'Select row',
    COLUMN: 'Column',
    ROW_NAME_DISPLAY: 'Row name display',
    BOTH: 'Both',
    SHARED_COLUMN_CONFIG_PRESET: 'Shared column config preset',
    SHOW_ZERO_SUM_ROWS: 'Show zero sum rows',
    USE_DATA_FROM_TIMELINE_SLICER: 'Use data from timeline slicer',
    USE_DATA_FROM_DIMENSION_SLICER: 'Use data from dimension slicer',
    DELETE_TARGET_AND_RELATED_DATA: 'and related data?',
    DELETE_TARGET_CHILDREN: 'Delete children of',
    DELETE_TARGET_DATA: 'Delete data for',
    CONFIRM_DELETE_ROW: 'Delete row?',
    CONFIRM_DELETE_ROWS: 'Delete {count} rows?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Delete generated rows?',
    CONFIRM_DELETE_ROWS_MIXED: 'Delete rows and generated rows?',
    EXPLAIN_DELETE_ROW: 'This will delete <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'This will delete generated rows from <>{table}<> from this sheet.',
    EXPLAIN_DELETE_ROWS_MIXED:
        'This will delete <>{count} row(s)<> and generated rows from <>{table}<> from this sheet.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'This will also delete any subrows. This action cannot be undone.',
    FAILED_DELETE_ROW: 'Failed to delete row',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'and all its subrows and items?',
    NO_ACCESS_TO_DELETE_ROWS: "You don't have access to the referenced rows, so you can't delete it.",
    CREATE_GROUP: 'Create group',
    EDIT_PERMISSIONS: 'Edit permissions',
    USERS_AND_GROUPS_MANAGEMENT: 'Users & Groups Management',
    SUM: 'Sum',
    COUNT: 'Count',
    AVERAGE: 'Average',
    CLOSING_STATE: 'Closing state',
    BEGINNING_STATE: 'Beginning state',
    FORMULA: 'Formula',
    MAX: 'Max',
    MIN: 'Min',
    YES: 'Yes',
    NO: 'No',
    YESTERDAY: 'Yesterday',
    CONFIRM_VARIABLE_REMOVE: 'Confirm variable remove',
    CONFIRM_VARIABLES_REMOVE: 'Confirm variables remove',
    REMOVE_VARIABLE_CONFIRMATION: 'Are you sure you want to remove variable',
    REMOVE_VARIABLES_CONFIRMATION: 'Are you sure you want to remove variables:',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Are you sure you want to remove {tagNumber} variables?',
    EDIT_VARIABLE: 'Edit variable',
    SHARE_VARIABLE: 'Share variable',
    DELETE_VARIABLE_DATA: 'Delete variable data',
    DELETE_VARIABLE: 'Delete variable',
    EXPAND_MORE: 'Expand more',
    COLLAPSE_ALL: 'Collapse all',
    SCROLL_TO_BOTTOM: 'Scroll to bottom',
    VARIABLE_METRICS: 'Variable metrics',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Name',
        Description: 'Description',
        Formula: 'Formula',
        Dimensions: 'Dimensions',
        'Read-only': 'Read-only',
        'Roll-up type': 'Roll-up type',
    },
    LOADING_DATA: 'Loading data…',
    SUCCESSFULLY_LOADED_DATA: 'Data loaded',
    LOADING_DATA_FAILED: 'Unable to load data',
    LOADING_DATA_FAILED_SUBTITLE: 'Try refreshing the page',
    WAITING: 'Waiting...',
    VIEW_LOGS: 'View Logs',
    LOADING_DATA_LOG: 'Loading data log',
    CALCULATION_STARTED: 'Calculation started.',
    CALCULATION_FINISHED: 'Calculation finished.',
    DATABASE_LOADED: 'Database loaded. Number of cells loaded: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: '{variableName} variable calculation started. Number of input cells: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED:
        '{variableName} variable calculation done. Number of cells: {numberOfCells}, out/in factor: {outInFactor}.',
    NEW_ROW: 'New row',
    NEW_TEMPLATE_OR_ROW: 'New',
    ADD_TEMPLATE_TO_TOOLBAR: 'Add to toolbar',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Remove from toolbar',
    IN_TOOLBAR: 'In toolbar',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Template added to toolbar',
    TEMPLATES: 'Templates',
    SELECT_A_ROW: 'Select a row',
    FILE_CANT_BE_PREVIEWED: 'File cannot be previewed',
    THIS_TYPE_OF: 'This type of',
    INPUT_SETUP: 'Input setup',
    ONDEMAND_CALCULATION: 'On-demand calculation',
    REFRESH_DATA: 'Refresh data',
    DISABLE_MAINTENANCE_MODE: 'Disable maintenance mode',
    ENABLE_MAINTENANCE_MODE: 'Enable maintenance mode',
    SAVED: 'Saved',
    FORMULA_ERROR: 'Formula error',
    UNEXPECTED: 'Unexpected',
    INVALID_SYNTAX: 'Invalid syntax for',
    MISSING_TOKEN_AFTER: 'Missing token after',
    UNNECESSARY: 'Unnecessary',
    ERROR_MESSAGE_OCCURRED: 'An error has occurred',
    INCOMPLETE_sheet_ITEM_DATA: 'Incomplete sheet item data',
    FAIL_SAVE_sheet_ITEMS: 'Failed to save sheet items',
    HEADER_COLUMNS: {
        Description: 'Description',
        Date: 'Date',
        Version: 'Version',
        'Variable and Dimensions': 'Variable and dimensions',
        Value: 'Value',
        'Value type': 'Value type',
        Action: 'Action',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Descriptions update for month and year to date tags failed.',
    COMPARISON: 'Comparison',
    DISALLOW: 'Disallow',
    USE_DEFAULT: 'Use default',
    SKIP_ROW: 'Skip row',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Will not allow import as long as there are missing members.',
    MISSING_MEMBERS_SKIP_ROWS: 'Will skip rows with missing members.',
    MISSING_MEMBERS_DEFAULT: 'Will import data from the missing members to the default member of the table.',
    CONFIGURE_JOB_OPTIONS: 'Configure job options',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Handle missing dimension members',
    IMPORT_ZEROS: 'Import zeros',
    OVERWRITE_CELLS: 'Overwrite cells',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Ignore financial year offset',
    SKIP_EMPTY_ROWS: 'Skip empty rows',
    SKIP_REPEATING_HEADER_ROWS: 'Skip repeating header rows',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Skip low-signal rows (heuristic)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: '{count} row(s) will be skipped on import.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'No rows will be skipped on import.',
    INCLUDE_IN_IMPORT: 'Include in import',
    EXCLUDE_FROM_IMPORT: 'Exclude from import',
    MISSING_MEMBERS_REPLACE_ALL: 'Replace all previous dimension members',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Are you sure you want to replace all previous dimension members?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Apply members and variables to value columns',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Got wrong result type for column {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Tried to add non unique tags',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Tried to create tag with empty name',
    NO_PARENT_TAG_SELECTED: 'No parent tag selected',
    COLUMN_MANAGER: 'Columns',
    NO_COLUMNS: 'No columns.',
    NEW_COLUMN_TIP:
        'You can start by adding a new column element. From there use the sidebar to select and create custom columns.',
    NEW_COLUMN: 'New column',
    COLUMN_TO_NUMBER_TYPE: 'Change to number',
    COLUMN_TO_COMPARISON_TYPE: 'Change to comparison',
    COMPARISON_OPERATION: 'Operation',
    DROP_ELEMENTS: 'Drop elements...',
    READONLY: 'Readonly',
    CUSTOM_TITLE: 'Custom title',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Select row to drop elements.',
    CANT_MOVE_ROW_INSIDE_SELF: "Can't move a row inside itself.",
    CLEAR_ALL: 'Clear all',
    MIGRATE_TO_SHEET: 'Migrate to sheet',
    CHOOSE_TIME_PERIOD: 'Please choose a time period',
    NO_VARIABLE: 'No variable',
    NO_ROWS_SELECTED: 'No rows selected',
    STARTING_YEAR_NOT_ACTIVE: 'Starting year not active',
    SHEET: 'Sheet',
    ASSIGNEE: 'Assignee',
    APPROVER: 'Approver',
    SHARED_TO: 'Shared to',
    PUBLIC: 'Public',
    PUBLIC_LINK: 'Public link',
    VERSIONS_AND_INTERVAL: 'Versions & Interval',
    INTERVAL: 'Interval',
    EXPIRES_IN: 'Expires in',
    STATUS: 'Status',
    STATUS_EXPIRES_IN: 'Status (Expires in)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Public assignment link copied to clipboard',
    EXPORTING: 'Exporting...',
    APPROVE: 'Approve',
    DISAPPROVE: 'Disapprove',
    EXPORT: 'Export',
    EXPIRE: 'Expire',
    REFRESH: 'Refresh',
    NO_ASSIGNMENTS_AVAILABLE: 'No assignments available.',
    MARK_IN_REVIEW: 'Mark as in review',
    MARK_AS_UNRESOLVED: 'Mark as unresolved',
    MARK_AS_RESOLVED: 'Mark as resolved',
    GO_TO_ROW: 'Go to row',
    DELETE_THREAD: 'Delete thread',
    REPLAY_OR_TAG_IN_COMMENT: 'Reply or tag others with @...',
    COMMENT_OF: 'Comment {arrowsCurrent} of {arrowsAll}',
    COMMENT: 'Comment',
    COMMENTS: 'Comments',
    LOADING_IMPORT_JOBS: 'Loading import jobs',
    IMPORT_ROWS_TRUNCATED_WARNING:
        'The dataset is too large to display completely. Only the first 200,000 rows are shown. All rows will still be imported when you commit.',
    SELECTED_JOB_DOESNT_EXIST: 'Selected job does not exist',
    GO_BACK_TO_IMPORT: 'Go back to import',
    BACK_TO_IMPORT: 'Back to import',
    AT_LEAST_ONE_CHART_LINE: 'You must add at least one chart line.',
    AT_LEAST_ONE_X_AXIS_TAG: 'You must add at least one x axis tag',
    VISUALIZATION_TYPE: 'Visualization type',
    VISUALISATION_OPTIONS: 'Visualisation options',
    EDIT_CHART: 'Editing chart "{title}"',
    BAR_CHART: 'Bar chart',
    BAR: 'Bar',
    STACKED_BAR_CHART: 'Stacked bar chart',
    STACKED_BAR: 'Stacked bar',
    WATERFALL_CHART: 'Waterfall chart',
    WATERFALL: 'Waterfall',
    PIN_CHART: 'Pin chart',
    PIN: 'Pin',
    AREA_CHART: 'Area chart',
    AREA: 'Area',
    STACKED_AREA_CHART: 'Stacked area chart',
    STACKED_AREA: 'Stacked area',
    LINE_CHART: 'Line chart',
    LINE: 'Line',
    COMBO_CHART: 'Combo chart',
    PIE_CHART: 'Pie chart',
    TRAFFIC_LIGHT: 'Traffic light',
    INDICATOR: 'Indicator',
    SINGLE_VALUE: 'Single value',
    CREATE_CHART: 'Create new chart',
    ORIENTATION_LAYOUT: 'Orientation & layout',
    HORIZONTAL: 'Horizontal',
    VERTICAL: 'Vertical',
    SINGLE: 'Single',
    GRID: 'Grid',
    THIN: 'Thin',
    THICK: 'Thick',
    DOUBLE: 'Double',
    DOT: 'Dot',
    CIRCLE: 'Circle',
    SQUARE: 'Square',
    CATEGORY_AXIS: 'Category axis',
    DOMAIN_AXIS: 'Domain axis',
    SHOW_TOTALS: 'Show totals',
    SHOW_AXIS: 'Show axis',
    SHOW_VALUE_AXIS: 'Show value axis',
    SHOW_CATEGORY_AXIS_LABELS: 'Show category axis labels',
    COMPACT_AXIS_LABELS: 'Compact axis labels',
    CATEGORY_LABEL_ANGLE: 'Category label angle',
    LABEL_FORMAT: 'Label format',
    SHOW_LEGEND: 'Show legend',
    SHOW_INTEGRATED_LEGEND: 'Show integrated legend',
    VALUE_LABELS: 'Value labels',
    ROW_VALUE_LABELS: 'Row value labels',
    SHOW_VALUE_LABELS: 'Show value labels',
    POSITION: 'Position',
    SMART_FILTERING: 'Smart filtering',
    TRANSPOSE_DATA: 'Transpose rows and columns',
    NORMALIZE_TO_PERCENT: 'Normalize to 100%',
    SHOW_EMPTY_ROWS: 'Show empty rows',
    SHOW_EMPTY_COLUMNS: 'Show empty columns',
    GROUP_BY_PARENT_ROW: 'Group by parent row',
    ACCUMULATE_DATA: 'Calculate running sum',
    COLOR_BY_VALUE: 'Color based on value',
    COLOR_BY_TREND: 'Color based on trend',
    COLOR_TOTALS_BY_VALUE: 'Color totals by value',
    THRESHOLD_VALUE: 'Threshold value',
    USE_SHARED_SCALE: 'Use shared scale',
    STATIC: 'Static',
    BY_VALUE: 'By value',
    BY_TREND: 'By trend',
    BAR_SPACING: 'Bar spacing',
    GAP: 'Gap',
    WIDTH: 'Width',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Use data from dimension slicers',
    X_AXIS_DIMENSION_BUILDER: 'X axis dimension builder',
    ADD_REMOVE_X_AXIS_COLUMN: 'Add/remove x axis column',
    Y_AXIS_ITEMS: 'Y axis items',
    ADD_CHART_LINE: 'Add chart line',
    UNLOCK_HIERARCHY: 'Unlock hierarchy',
    LOCK_HIERARCHY: 'Lock hierarchy',
    MATERIALIZE: 'Materialize',
    MORE_OPTIONS: 'More options',
    LOCK_ROW: 'Lock row',
    LOCK_COLUMN: 'Lock column',
    PASTE: 'Paste',
    COPY: 'Copy',
    CUT: 'Cut',
    PASTE_ROWS: 'Paste row(s)',
    COPY_ROWS: 'Copy row(s)',
    CUT_ROWS: 'Cut row(s)',
    MOVING_ROWS: 'Moving rows...',
    PASTING_ROWS: 'Pasting rows...',
    CONFIRM_LOCK: 'Confirm lock',
    CONFIRM_UNLOCK: 'Confirm unlock',
    CONFIRM_LOCK_AND_CHILDREN: 'Are you sure you want to lock this row and its children?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Are you sure you want to unlock this row and its children?',
    SEARCH_FOR_IMPORTS: 'Search for imports',
    NEW_IMPORT: 'New import',
    IMPORTER: 'Importer',
    CREATION_DATE: 'Creation date',
    ACTIONS: 'Actions',
    ADD_ACTION: 'Add action',
    ADD_ARGUMENT: 'Add argument',
    EDIT_ACTION: 'Edit action',
    ACTION_NAME: 'Action name',
    ARCHIVE: 'Archive',
    REPLACE: 'Replace',
    STATUS_MESSAGE_MAP: {
        'In progress': 'In progress',
        Commited: 'Committed',
        Archived: 'Archived',
        Reverted: 'Reverted',
    },
    EDIT_TILE: 'Edit tile',
    FOCUS_TILE: 'Focus tile',
    UNFOCUS_TILE: 'Unfocus tile',
    MOVE_TO: 'Move to',
    ADD_ROW: 'Add row',
    ADD_COLUMN: 'Add column',
    EDIT_ROW: 'Edit row',
    FROM: 'From',
    TO: 'To',
    GLOBAL_FORMATTING: 'Global formatting',
    FAIL_SAVE_CHANGES: 'Failed to save changes.',
    TAG_NAME_EXISTS: 'Tag name already exists.',
    MUST_CHOOSE_TYPE: 'You must choose a type',
    MUST_ENTER_TAG_NAME: 'You must enter a name for the tag',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: "Tag name can't contain quotation marks.",
    INVALID_VARIABLE_TAG_FORMAT: 'Invalid variable tag format: {tagFormat}',
    INVALID_FORMULA: 'Invalid formula.',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Function {image} is not allowed on dimension tags.',
    CREATE_DATABASE_OBJECT: 'Create database object',
    EDIT_TAG_TYPE_NAME: 'Edit {tagType} "{tagName}"',
    PARENT: 'Parent',
    ROOT: 'Root',
    SEARCH_OR_SELECT_PARENT_TAG: 'Search or select parent tag',
    ROLLUP_TYPE: 'Roll-up type',
    DATA_TYPE: 'Data type',
    FORMAT_TYPE: 'Format type',
    CHOOSE_FORMATTING_OPTION: 'Choose formatting option',
    ENTER_CUSTOM_FORMAT: 'Enter custom format',
    CUSTOM_FORMAT: 'Custom format',
    TOP_DOWN: 'Top down',
    TOP_DOWN_DATA_MAPPING: 'Top down data mapping',
    CONNECTED: 'Connected',
    ADD_CONNECTED_VARIABLE: 'Add connected variable',
    REVERSE_CONNECTED: 'Reverse connected',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Add reverse connected variable',
    DIMENSIONS: 'Dimensions',
    ADD_DIMENSION: 'Add dimension',
    ADVANCED: 'Advanced',
    CALCULATE_ON_DEMAND: 'Calculate on demand',
    TRIGGER_ON_DEMAND_CALCULATION: 'To trigger On-Demand calculation, go to "Input Setup"',
    OPTIMIZE_CALCULATION: 'Optimize calculation',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Constrained light top down',
    USE_HIERARCHY_IN_CALCULATION: 'Use hierarchy in calculation',
    MAPPING_TO_VARIABLE: 'Mapping to variable',
    ADD_FROM_VERSION: 'Add from version',
    MAPPING_FROM_VERSION: 'Mapping from version',
    MAPPING_TO_VERSION: 'Mapping to version',
    ADD_TO_VERSION: 'Add to version',
    USED_IN_FORMULA: 'Used in 1 formula',
    USED_IN_FORMULAS: 'Used in {numberOfTags} formulas',
    TABLE_BACKLINKS: 'Referenced by {{1 table|?? tables}}',
    VARIABLE_BACKLINKS: 'Used by {{1 variable|?? variables}}',
    ACTIVE: 'Active',
    CONNECTED_DIMENSION: 'connected dimension',
    MY_ACCOUNT: 'My account',
    SIGN_OUT: 'Sign out',
    LOG_OUT: 'Log out',
    EDIT_PROFILE: 'Edit profile',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    DATA_HUB: 'Data Hub',
    DATASETS: 'Datasets',
    PIPELINES: 'Pipelines',
    NAMESPACE: 'Namespace',
    SEARCH_FOR_DATASETS: 'Search for datasets',
    NO_DATASETS_YET: 'No datasets yet. Datasets are created when pipelines run with dataset storage.',
    SEARCH_FOR_PIPELINES: 'Search for pipelines',
    NO_PIPELINES_YET: 'No pipelines yet. A pipeline is an app that runs on the pipelines runner.',
    PROFILE_AND_SUPPORT: 'Profile & support',
    RENAME_TABLE: 'Rename table',
    SHARE_TABLE: 'Share table',
    DELETE_TABLE_DATA: 'Delete table data',
    DELETE_TABLE_MEMBERS: 'Delete table members',
    DELETE_TABLE_DIMENSIONS: 'Delete table dimensions',
    DELETE_TABLE: 'Delete table',
    DELETE_ROW: 'Delete row',
    DELETE_ROWS: 'Delete row(s)',
    SHOW_VALUE: 'Show value',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Show variables and dimensions',
    FREEZE_PANES: 'Freeze panes',
    FREEZE_UP_TO_THIS_ROW: 'Freeze up to this row',
    FREEZE_UP_TO_THIS_COLUMN: 'Freeze up to this column',
    UNFREEZE_ROWS: 'Unfreeze rows',
    UNFREEZE_COLUMNS: 'Unfreeze columns',
    HIDE_GRIDLINES: 'Hide gridlines',
    HIDE_ROW_COLUMN_HEADERS: 'Hide row/column headers',
    LABELS: 'Labels',
    ADD_LABEL: 'Add label',
    ERROR_LABEL_EXISTS: 'Label already exists!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Error renaming import job label!',
    IMPORT_JOB_LABEL_RENAMED: 'Import job label renamed',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Error deleting import job label!',
    IMPORT_JOB_LABEL_DELETED: 'Import job label deleted',
    CREATE_OR_SEARCH: 'Create or search...',
    CREATE: 'Create',
    NAME_AND_DESCRIPTION: 'Name and Description',
    SUBTOTALS: 'Subtotals',
    TOTAL: 'Total',
    DISABLED: 'Disabled',
    BEFORE: 'Before',
    AFTER: 'After',
    UNSELECT_ALL: 'Unselect all',
    SAVE_CONFIG_FOR_ALL: 'Save config for all',
    SAVE_CONFIG_FOR_ALL_TOOLTIP:
        'Saves the current finder state, filters, timeline & sheet options as the default configuration.',
    EDIT_DIMENSION_SLICER: 'Editing dimension slicer "{title}"',
    CREATE_DIMENSION_SLICER: 'Create new dimension slicer',
    ENABLE_MULTISELECT: 'Enable multi-select',
    DISPLAY_MULTIPLE_VALUES: 'Display multiple values',
    SEARCH_AND_AUTO_SELECT: 'Search & auto-select',
    BLANKS: '(Blanks)',
    ENTER_TITLE: 'Enter title...',
    TAG_NAME_DISPLAY: 'Tag name display',
    FILTERS: 'Filters',
    ADD_FILTER: 'Add filter',
    BY_DIMENSION: 'By dimension',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Show only dimensions with data in...',
    EDIT_SINGLE_VALUE: 'Editing single value "{title}"',
    CREATE_SINGLE_VALUE: 'Create new single value',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Leave empty for auto-generated',
    FILTER_DIMENSIONS: 'Filter dimensions',
    COMPARISON_DIMENSIONS: 'Comparison dimensions',
    COMPARISON_CUSTOM_TEXT: 'Comparison custom text',
    DATA_ENTRY: 'Data entry',
    SHOW_BUTTONS: 'Show buttons',
    STEP: 'Step',
    AND: 'and',
    OR: 'or',
    DOWNSTREAM_FILTERS: 'Downstream filters',
    TO_TABLE: 'To table',
    FROM_TABLE: 'From table',
    ADD_DOWNSTREAM_FILTER: 'Add downstream filter',
    FLAT: 'Flat',
    HIERARCHY_MAX_DEPTH: 'Hierarchy max depth',
    APPLICATION_VERSION: 'Application version',
    CONFIRM_TAG_REMOVE: 'Confirm tag remove',
    CONFIRM_TAGS_REMOVE: 'Confirm tags remove',
    REMOVE_TAG_CONFIRMATION: 'Are you sure you want to remove tag {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Are you sure you want to remove tags: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Are you sure you want to remove {tagNumber} tags?',
    ERROR_PARSING_NUMBER: 'Error parsing number',
    ERROR_PARSING_DATE: 'Error parsing date',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Please use context menu for updating file column',
    ERROR_PARSING_INPUT_NUMBER: 'Error parsing input number',
    ERROR_SAVING_DATA: 'Error saving data',
    DATA_ENTRY_NOT_ALLOWED: 'Data entry not allowed',
    ERROR_PARSING_STEP_VALUE: 'Error parsing step value',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} cells',
    UNKNOWN_VARIABLE_CELLS: 'Unknown variable: {cellNumber} cells',
    SUCCESS_IMPORTED_CELLS: 'Success! Imported cells: {accountTags}',
    IMPORTED_CELLS: 'Imported cells',
    IMPORT_JOB_DELETING: 'Deleting import job',
    IMPORT_JOB_DELETING_CONFIRM: 'Are you sure you want to delete import job {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Delete & keep data',
    DELETE_JOB_AND_DATA: 'Delete job and data',
    ADD_DIMENSIONS_TO_JOB: 'Add dimensions to job',
    CONFIGURE: 'Configure',
    ADD_DESCRIPTION_FOR_IMPORT: 'Add a description for this import',
    UNDO: 'Undo',
    SETTINGS: 'Settings',
    BASIC_SETTINGS: 'Basic settings',
    OTHER_SETTINGS: 'Other settings',
    TABLE_NAME: 'Table name',
    AUTOGENERATE_DIMENSION_NAMES: 'Autogenerate dimension names',
    AUTOGENERATE_NAMES_CONFIG: 'Autogenerate names config',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'eg. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION:
        'Define a custom config to autogenerate names for this table. Use the predefined tokens below with curly braces. You can put any character between the tokens.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'You can use these tokens to define your config',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (March 20th, 2023)',
    ENTRY: 'Entry',
    STEP_MUST_BE_NUMBER: 'Step must be a number.',
    EDIT_DATA_EDITOR: 'Editing data editor "{title}"',
    BUTTON_CONTROLS: 'Button controls',
    BOLD: 'Bold',
    ITALIC: 'Italic',
    UNDERLINED: 'Underlined',
    OUTLINED: 'Outlined',
    FONT_SIZE: 'Font size',
    FILE_SIZE: 'File size',
    SMALL: 'Small',
    MEDIUM: 'Medium',
    LARGE: 'Large',
    CREATE_NEW_COLUMN: 'Create new column',
    EDIT_COLUMN_WITH_LABEL: 'Edit column "{label}"',
    COLUMN_TAGS: 'Column tags',
    DELETE_THIS_COLUMN: 'Delete this column',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Select parent tag to generate multiple columns',
    USING_SHARED_COLUMN_CONFIG: 'Using shared column config',
    SLICER_GENERATED: 'Slicer generated',
    HEADER_CANNOT_BE_EMPTY: 'Header cannot be empty',
    MUST_CHOOSE_A_FORMAT: 'You must choose a format',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Calculation fields cannot be empty',
    ADD_NEW_COLUMN: 'Add new column',
    HEADER: 'Header',
    SUBHEADER: 'Subheader',
    TYPE: 'Type',
    POLARITY: 'Polarity',
    CONDITIONAL_FORMATTING: 'Conditional formatting',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Relative',
        Absolute: 'Absolute',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Positive',
        Negative: 'Negative',
        Neutral: 'Neutral',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Regular',
        Calculated: 'Calculated',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Off',
        Traffic: 'Traffic lights',
        Databar: 'Data bar',
        Colorscale: 'Color scale',
        Arrows: 'Arrow up and down',
    },
    HIDE_NUMBERS: 'Hide numbers',
    COLUMN_ONE: 'Column 1',
    COLUMN_TWO: 'Column 2',
    LITERAL: 'literal',
    FUNCTION: 'function',
    FUNCTIONS: 'Functions',
    EXAMPLE: 'Example',
    EDIT_IN: 'Edit {type}',
    OPEN_IN_EDITOR: 'Open in {type} editor',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Every week on a {day} at {time}',
    REMOTE_JOB_SCHEDULED: 'Scheduled {schedule}',
    SCHEDULE: 'Schedule',
    EVERY: 'Every',
    EVERY_HOUR_AT: 'Every hour at',
    EVERY_DAY_AT: 'Every day at',
    RUN_JOB: 'Run job',
    RUN: 'Run',
    APP_WITH_ID: 'App #{id:number}',
    PIPELINE_RUNS_LOAD_FAILED: "Could not load this app's runs.",
    PIPELINE_RUN_NOT_FOUND: "Run #{runId:number} is not in this app's run history.",
    PIPELINE_SHOW_LATEST_RUN: 'Show the latest run',
    PIPELINE_OUTPUT: 'Output',
    PIPELINE_OUTPUT_IN_FILES: 'Stored in Files. This store keeps only the latest output, not the output of each run.',
    PIPELINE_OUTPUT_STATE_MAP: {
        published: 'Published by this run',
        completed: 'Written by this run, not published',
        started: 'Started by this run, not completed',
    },
    PIPELINE_OUTPUT_BEING_WRITTEN: 'Being written by this run',
    PIPELINE_OUTPUT_NOT_RECORDED:
        "A dataset with this step's name exists. This run did not record writing it, so it opens on its current version.",
    PIPELINE_PEEK_TOO_LARGE: 'This version is too large for a peek. Open this version to preview it.',
    PIPELINE_PEEK_EMPTY: 'This version has no rows.',
    PIPELINE_PEEK_FIRST_ROWS: 'First {shown:string} of {total:string} rows',
    PIPELINE_PEEK_ALL_ROWS: 'All {total:string} {{count:row|rows}}',
    PIPELINE_OUTPUT_PAYLOAD: "The source's file as this run stored it, kept 30 days",
    PIPELINE_PAYLOAD_PEEK_TOO_LARGE: 'This file is too large for a peek. Download it to open it.',
    PIPELINE_PAYLOAD_PEEK_EMPTY: 'This file has no rows.',
    PIPELINE_PAYLOAD_NO_PEEK: 'No peek for {format:string} files. The step that parses this file shows its data.',
    OPEN_IN_FILES: 'Open in Files',
    PIPELINE_SELECT_STEP: 'Select a step in the graph to see its details.',
    PIPELINE_WAITING_FOR_STEPS: 'This run has not recorded a step yet.',
    RUN_LOGS: 'Run logs',
    PIPELINE_STEP_NOT_IN_RUN: '{step:string} is not in this run.',
    QUEUED: 'Queued',
    RUNNING: 'Running...',
    UNAVAILABLE: 'Unavailable',
    MINUTES: 'minutes',
    JOBS: 'Jobs',
    JOB_LOGS: 'Job logs',
    PREFERRED_RUNNER: 'Preferred runner',
    RUNNER_DISCONNECTED: 'This runner is currently disconnected.',
    RUNNER_IMAGE: 'Runner image',
    WHERE_RUNS_HAPPEN: 'Where runs happen',
    COMPUTE_SHARED_RUNNER: 'On the shared runner',
    COMPUTE_OWN_MACHINE_SIZE: 'Own machine ({size:string})',
    COMPUTE_OWN_MACHINE_DEFAULT_SIZE: 'Own machine (default size)',
    COMPUTE_WARNING: {
        nothingConnected: 'No runner is connected, so nothing is known about where this job can run.',
        namedRunnerNotConnected:
            'The runner this job names is not connected, so nothing is known about where this job can run.',
        namedRunnerOffersNoOwnMachine: 'The runner this job names cannot create a machine, so this job will not run.',
        noRunnerOffersOwnMachine: 'No connected runner can create a machine, so this job will not run.',
        namedRunnerOffersNoSharedRun:
            'The runner this job names only runs jobs on its own machine, so this job will not run.',
        noRunnerOffersSharedRun: 'No connected runner runs jobs on a shared runner, so this job will not run.',
        namedRunnerOffersNothing:
            'The runner this job names only runs jobs on its own machine and cannot create one, so this job will not run.',
        noRunnerOffersAnything:
            'No connected runner runs jobs on a shared runner, and none can create a machine, so this job will not run.',
    },
    RUNNER_IMAGE_TAG: 'Version',
    LOGS: 'Logs',
    REMOTE_JOBS: 'Apps',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Version',
        Year: 'Year',
        Month: 'Month',
        Quarter: 'Quarter',
        'Half Year': 'Half year',
        'Year to Date': 'Year to date',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Variable/Table/Dimension/Group',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Add new {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Integer',
        Decimal: 'Decimal',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Custom',
        Number: 'Number',
        Currency: 'Currency',
        Percentage: 'Percentage',
        Date: 'Date',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Dashboard',
        Sheets: 'Sheets',
        Import: 'Import',
        'Remote jobs': 'Apps',
        Dimensions: 'Dimensions',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Dimension table',
        DIMENSION_MEMBER: 'Dimension member',
        VARIABLE: 'Variable',
        FOLDER: 'Folder',
        FUNCTION: 'Function',
        LITERAL: 'Literal',
        PROPERTY: 'Property',
        FILE: 'File',
        DASHBOARD: 'Dashboard',
        REMOTE_JOB: 'App',
        SHEET: 'Sheet',
        TILE: 'Tile',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Dimension tables',
        DIMENSION_MEMBER: 'Dimension members',
        VARIABLE: 'Variables',
        FOLDER: 'Folders',
        FUNCTION: 'Functions',
        LITERAL: 'Literals',
        PROPERTY: 'Properties',
        FILE: 'Files',
        DASHBOARD: 'Dashboards',
        REMOTE_JOB: 'Apps',
        SHEET: 'Sheets',
        TILE: 'Tiles',
    },
    ITEM: 'Item',
    ITEM_TYPE: 'Item type',
    FOLDER_ITEM: {
        DASHBOARD: 'Dashboard',
        DIMENSION_TABLE: 'Dimension table',
        VARIABLE: 'Variable',
        SHEET: 'Sheet',
        FOLDER: 'Folder',
        FARSEER_FILE: 'File',
        REMOTE_JOB: 'App',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Dashboards',
        DIMENSION_TABLE: 'Dimension tables',
        VARIABLE: 'Variables',
        SHEET: 'Sheets',
        FOLDER: 'Folders',
        FARSEER_FILE: 'Files',
        REMOTE_JOB: 'Apps',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'generates a universal unique identifier',
        YYYY: 'inserts the current year',
        YY: 'inserts the last two digits of the current year (short year)',
        MM: 'inserts the current month',
        DD: 'inserts the current day',
        SSSSSSSS:
            'inserts the serial number from current table children length + 1, define the length by the amount of “S” characters (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Users & permissions',
        'Users & Groups': 'Users & groups',
        System: 'System',
        'Input Setup': 'Input setup',
        Locks: 'Locks',
        'Backup & Restore': 'Backup & restore',
        'Audit Logs': 'Audit logs',
        'Export Model': 'Export model',
        'Import Model': 'Import model',
        'Switch Tenants': 'Switch workspace',
        Support: 'Support',
        'Help Center': 'Help center',
        'Contact Support': 'Contact support',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'minus',
        divide: 'divide',
        plus: 'plus',
        multiply: 'multiply',
        percent: 'percent',
        'percent thousands': 'percent thousands',
        'difference in %': 'difference in %',
    },
    STATUS_MAP: {
        Resolved: 'Resolved',
        Unresolved: 'Unresolved',
        'In Review': 'In review',
        QUEUED: 'QUEUED',
        RUNNING: 'RUNNING',
        FINISHED: 'FINISHED',
        ERROR: 'ERROR',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Create user',
        'Delete User': 'Delete user',
        'Find All Users': 'Find all users',
        'Get User': 'Get user',
        'Update User': 'Update user',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Row/column toolbar',
        CLUSTER_FLOW_ADD: 'Row add',
        YEAR_VERSION_LOCKS: 'Locks',
        IMPORT: 'Import',
        SEE_ALL_IMPORT_JOBS: 'See all import jobs',
        USERS_GROUPS_MANAGEMENT: 'Users & groups management',
        REMOTE_JOBS: 'Apps',
        COMMENTS: 'Comments',
        TAGS_SIDEBAR: 'Database sidebar',
        CREDENTIALS: 'Credentials',
        INPUT_SETUP: 'Input setup',
        AUDIT_LOGS: 'View audit logs',
        ASSIGNMENTS: 'Assignments',
        BACKUP_AND_RESTORE: 'Backup & restore',
        DASHBOARD_TO_IMAGE: 'Dashboard to image',
        CHAT_AI: 'Chat AI',
        DELETE_DIMENSION: 'Delete dimension',
        FORECAST: 'Forecast',
        GOAL_SEEKING_TOP_DOWN: 'Goal seeking top down',
        MODEL_IMPEX: 'Model import/export',
        OWD_MEASURES: 'Only with data for measures',
        FORMULA_QA: 'Formula QA',
        USE_HIERARCHY_IN_CALCULATION: 'Update "use hierarchy" in variables',
        MODEL_HEALTH: 'Model health',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Farseer logo',
        SHARED_WITH_ME: 'Shared with me',
        API_KEY_MANAGEMENT: 'API key management',
        DATA_HUB: 'Data Hub (reads every dataset)',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Edit cells',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Create folder',
        'Duplicate Folder': 'Duplicate folder',
        'Search Folders': 'Search folders',
        'Get Items in Folder': 'Get items in folder',
        'Find by Reverse References': 'Find by reverse references',
        'Move Items': 'Move items',
        'Rename Items': 'Rename items',
        'Delete Items in Folder': 'Delete items in folder',
        'Share Folder Hierarchy': 'Share folder hierarchy',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Create database object',
        'Delete Database Object': 'Delete database object',
        'Get Database Object': 'Get database object',
        'Update Database Object': 'Update database object',
        'Search Database Objects': 'Search database objects',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Create sheet',
        'Get Sheet': 'Get sheet',
        'Update Sheet': 'Update sheet',
        'Duplicate Sheet': 'Duplicate sheet',
        'Search Rows in Sheet': 'Search rows in sheet',
        'Get Sheet Data': 'Get sheet data',
        'Set Sheet Data': 'Set sheet data',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Create row',
        'Update Row': 'Update row',
        'Delete Row': 'Delete row',
        'Move Row': 'Move row',
        'Duplicate Row': 'Duplicate row',
        'Find All Row': 'Find all rows',
        'Get Row': 'Get row',
        'Materialize Row': 'Materialize row',
    },
    SHEET_LINE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Line': 'Create sheet line (row or column)',
        'Update Line': 'Update sheet line',
        'Delete Line': 'Delete sheet line',
        'Duplicate Line': 'Duplicate sheet line',
        'Materialize Line': 'Materialize sheet line',
        'Get Line': 'Get sheet line',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Create share',
        'Add Public Shares': 'Add public shares',
        'Delete Share': 'Delete share',
        'Get Share': 'Get share',
        'Update Share': 'Update share',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Get label',
        'Create Label': 'Create label',
        'Update Label': 'Update label',
        'Delete Label': 'Delete label',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Create file',
        'Update File': 'Update file',
        'Delete File': 'Delete file',
        'Find All Files': 'Find all files',
        'Get File': 'Get file',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Create app',
        'Update Remote Job': 'Update app',
        'Find All Remote Jobs': 'Find all apps',
        'Get Remote Job': 'Get app',
        'Run Remote Job': 'Run app',
        'Run Remote Job As A Service': 'Run app as a service',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Restore backup',
        'Create Backup': 'Create backup',
        'Search Backups': 'Search backups',
        'Download Backup': 'Download backup',
        'Upload Backup': 'Upload backup',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Read model',
        'Edit Model': 'Edit model',
    },
    SETTING_CLASS_PERMISSIONS_TITLE_MAP: {
        'Update Global Locks': 'Update locks',
        'Update Financial Year': 'Update financial year start',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Create dashboard',
        'Duplicate Dashboard': 'Duplicate dashboard',
        'Find All Dashboards': 'Find all dashboards',
        'Get Dashboard': 'Get dashboard',
        'Update Dashboard': 'Update dashboard',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Feature permission',
        FolderClassPermission: 'Folder class permission',
        TagClassPermission: 'Tag class permission',
        SheetClassPermission: 'Sheet class permission',
        SheetRowClassPermission: 'Sheet row class permission',
    },
    SEARCH_TAGS: 'Search tags...',
    SEARCH_PERMISSIONS: 'Search for permissions...',
    DEFAULT: 'Default',
    FEATURE_PERMISSIONS: 'Feature permissions',
    CLASS_PERMISSIONS: 'Class permissions',
    ADD_COMMENT: 'Add comment',
    SORT: 'Sort',
    SORT_BY: 'Sort by',
    ASCENDING: 'Ascending',
    DESCENDING: 'Descending',
    UNSORT: 'Unsort',
    AUTO: 'Auto',
    LEFT: 'Left',
    ALL_MONTHS: 'All months',
    TWELVE_MONTHS: '12 months',
    YEAR_START: 'Year start',
    TIMELINE_START: 'Timeline start',
    COPY_HASH_TAG: 'Copy #',
    SHOW_TOP: 'Show top',
    SHOW_REST: 'Show rest',
    RIGHT: 'Right',
    CENTER: 'Center',
    TOP: 'Top',
    MIDDLE: 'Middle',
    BOTTOM: 'Bottom',
    YEAR_END: 'Year end',
    TIMELINE_END: 'Timeline end',
    CURRENT_YEAR: 'Current year',
    PREVIOUS_YEAR: 'Previous year',
    CUSTOM: 'Custom',
    NEW_TABLE: 'New {name}',
    EDIT_TABLE: 'Edit {name}',
    FOCUS_TABLE: 'Focus {name}',
    ROUND: 'Round',
    REGRESSION: 'Regression',
    RANDOM: 'Random',
    SET_VALUE: 'Set value',
    APPLY_PERCENTAGE: 'Apply percentage',
    APPLY_PERCENTAGE_CHAR: 'Apply %',
    DELETE_COLUMNS_ON_ROW: 'Delete columns on row',
    PROCESSING_FILE: 'Processing file',
    IMAGE_PREVIEW_FAILED: 'Unable to preview image',
    NEXT: 'Next',
    PREVIOUS: 'Previous',
    PAGE_OF: 'Page {pageNumber} of {pages}',
    NO_TITLE: 'No title',
    DURATION: 'Duration',
    CELL_COUNT: 'Cell count',
    NONCALCULATED: 'Non-calculated',
    CALCULATED: 'Calculated',
    SEARCH_ASSIGNMENTS: 'Search assignments',
    BY_NAME: 'By name',
    BY_LABEL: 'By label',
    BY_STATUS: 'By status',
    BY_SHEET: 'By sheet',
    GROUP_BY: 'Group by',
    CHART_SPACING: 'Chart spacing',
    GRID_COLUMNS: 'Grid columns',
    GRID_SPACING: 'Grid spacing',
    AXIS_SPACING: 'Axis spacing',
    RESET_FILTERS: 'Reset filters',
    RESET_CONFIG: 'Reset config',
    RESET_CONFIG_TOOLTIP: 'Resets the finder state, filters, timeline & sheet options to the default configuration.',
    BY_ASSIGNEE: 'By assignee',
    BY_APPROVER: 'By approver',
    NEW_ASSIGNMENT: 'New assignment',
    NEXT_ASSGN_DUE: 'The next assignment is due on ',
    SHARE_SELECT_USER_PLACEHOLDER: 'Search for users or groups...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Search for a user to assign to the sheet...',
    ASSIGNMENT_REFRESHED: 'Extended assignment(s) deadline by 7 days',
    CANT_EDIT_ASSIGNMENT: 'Can’t edit already submitted assignment(s)',
    NO_CHANGES: 'No changes',
    APPROVED: 'Approved',
    EXPIRED: 'Expired',
    READY_FOR_REVIEW: 'Ready for review',
    IN_PROGRESS: 'In progress',
    SHARED: 'Shared',
    SHARED_WITH: 'Shared with',
    SHARED_WITH_ME: 'Shared with me',
    SHARED_WITH_ME_TRUNCATED: 'Showing only the first {limit:number} shared items',
    ARCHIVED: 'Archived',
    STILL_STUCK: 'Still stuck? Visit our help center.',
    NEED_HELP: 'Need help? Visit our help center.',
    WELCOME: 'Welcome',
    WELCOME_MESSAGE: 'Select something from the sidebar to get started, or search for something specific.',
    DEFAULT_MEMBER: 'Default member',
    FAILED_TO_LOAD_MODEL: 'Failed to load model',
    MODEL_LOADED: 'Model loaded',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Your previous message is being processed. Please wait...',
    RUN_ARGUMENTS: 'Run arguments',
    EXPECTED_ARGUMENTS: 'Expected arguments',
    RUN_ARGUMENTS_ERROR: 'Run arguments for the action are outdated, please update them.',
    RUNS: 'Runs',
    PIPELINE: 'Pipeline',
    PIPELINE_TAB_NO_RUNS: 'Run this app to see its pipeline.',
    PIPELINE_TAB_NO_MARKERS:
        "This pipeline's runs do not record their steps. Add experimental__emit_pipeline_visualization_markers=True to run_pipeline in main.py.",
    PIPELINE_STEP_TYPE_MAP: {
        extraction: 'Extract',
        parse: 'Parse',
        transform: 'Transform',
        load: 'Load',
        export: 'Export',
        unknown: 'Step',
    },
    PIPELINE_STEP_STATUS_MAP: {
        PENDING: 'Pending',
        RUNNING: 'Running',
        OK: 'Completed',
        EXTRACTED: 'Extracted',
        LOADED: 'Loaded',
        EXPORTED: 'Exported',
        SKIPPED: 'Skipped',
        FAILED: 'Failed',
    },
    PIPELINE_STEP_POSITION: 'Step {index:number} of {total:number}',
    PIPELINE_STEP_ARIA_LABEL: 'Pipeline step {name:string}, status {status:string}',
    PIPELINE_QUALITY_WARNINGS: '{count:number} quality {{warning|warnings}}',
    PIPELINE_DATASET_COUNT: '{count:number} {{dataset|datasets}}',
    PIPELINE_COMPLETED_IN: 'Completed in {duration:string}',
    PIPELINE_STEPS_EXECUTED: '{done:number}/{total:number} steps executed',
    PIPELINE_STEPS_DONE: '{done:number}/{total:number} steps done',
    PIPELINE_FAILED_BEFORE_STEPS: 'Pipeline failed before any step ran: {error:string}',
    PIPELINE_NO_STEPS: 'No pipeline steps found',
    ROWS: 'Rows',
    DEPENDS_ON: 'Depends on',
    SOURCE: 'Source',
    SECONDS_SHORT: '{seconds:string}s',
    SYSTEM: 'system',
    BASIC_INFO: 'Basic info',
    LAST_RUN: 'Last run',
    NEVER_RUN: 'Never run',
    REMOTE_JOB_NAME: 'App name',
    CHOOSE_FOLDER: 'Choose folder',
    SOURCE_FOLDER: 'Source folder',
    SELECT_SOURCE_FOLDER_WARNING: 'Please select a source folder',
    MAIN_FILE_HINT: 'press on the file pill to mark the script file as entrypoint',
    NO_FILES: 'No files',
    NO_MAIN_FILE: 'No main file',
    FINDER_TOOLTIP: 'Show finder',
    VARIABLE_TOOLTIP: 'Show variable bar',
    sheet_ITEMS_TOOLTIP: 'Show sheet items',
    LIST_ITEMS_TOOLTIP: 'Show list items',
    EXPAND_TOOLTIP: 'Expand all rows by one level',
    COLLAPSE_TOOLTIP: 'Collapse all rows by one level',
    UNDO_TOOLTIP: 'Undo',
    REDO_TOOLTIP: 'Redo',
    UNDO_HISTORY_RESET: 'Undo history was reset',
    UNDO_UNAVAILABLE_NOT_SUPPORTED: "This change can't be undone",
    UNDO_UNAVAILABLE_TOO_LARGE: 'This change is too large to undo',
    UNDO_UNAVAILABLE_NO_INVERSE: 'Undo is no longer available',
    UNDO_UNAVAILABLE_NO_LONGER_ALLOWED: 'This change can no longer be undone',
    UNDO_UNAVAILABLE_GENERIC: "This change can't be undone",
    FORECAST_TOOLTIP: 'Show forecast progress',
    EXPORT_TOOLTIP: 'Export to .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'App shortcuts',
    TAGS_SIDEBAR_TOOLTIP: 'Open database objects sidebar',
    TILE_SIDEBAR_TOOLTIP: 'Open tile editing sidebar',
    COMMENTS_SIDEBAR_TOOLTIP: 'Open comments sidebar',
    ADD_APP_SHORTCUT: 'Add shortcut',
    APP_SHORTCUTS_PATH: 'App shortcuts',
    CHANGE_SHORTCUT_ACTION: 'Change action',
    REMOVE_SHORTCUT: 'Remove shortcut',
    SHORTCUT_ADDED: 'Shortcut added successfully',
    SHORTCUT_REMOVED: 'Shortcut removed',
    SHORTCUT_ALREADY_EXISTS: 'Shortcut already exists',
    CHANGE_ACTION_TITLE: 'Change action',
    CHANGE_ACTION_LABEL: 'Choose one of the following actions',
    ACTION_CHANGED: 'Action changed',
    ERROR_FETCHING_APP_DATA: 'Error fetching app data',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Error fetching action arguments',
    INVALID_ACTION_ARGUMENTS: 'Invalid action arguments',
    APP_STARTED_SUCCESSFULLY: 'App started successfully',
    CREATE_BACKUP: 'Create backup',
    BACKUP: 'Backup',
    CREATE_BACKUP_WARNING: 'Are you sure you want to create new backup?',
    RESTORE_BACKUP: 'Restore backup',
    RESTORE: 'Restore',
    RESTORE_BACKUP_WARNING: 'Are you sure you want to restore to backup {backupPath}?',
    COPY_WORKSPACE: 'Copy workspace',
    SELECT_WORKSPACE: 'Select workspace',
    COPY_WORKSPACE_ONTO: 'Copy onto {workspace}',
    COPY_WORKSPACE_WARNING:
        'Everything in this workspace will be replaced by a copy of the selected workspace. A backup of this workspace is created first, and the copy can take several minutes.',
    COPY_WORKSPACE_STARTED: 'Workspace copy started. This workspace will be unavailable until it finishes.',
    SELECT_MONTH: 'Select month',
    REMOVE_FILTER: 'Remove filter',
    FILTER_BY: 'Filter by...',
    STATIC_FILTER: 'This filter cannot be modified',
    SELECT_ROW_TO: 'Select a row to view or edit its variable',
    EDIT_ARGUMENT: 'Edit argument',
    ARGUMENT_NAME: 'Argument name',
    DATA_TYPE_STRING: 'String',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Default value',
    ADD_OPTION: 'Add option',
    OPTION_VALUE: 'Option value',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Options must be unique',
    DROPDOWN_OPTION_EMPTY: 'Option must not be empty',
    DROPDOWN_DEFAULT_AUTO_HINT: 'No default selected — the first option will be used on save.',
    LOCKED_AT_RUN_TIME: 'Lock value at run time',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'When checked, users running the app cannot override this value.',
    LOCKED_REQUIRES_DEFAULT: 'A locked argument must have a default value',
    SECRET: 'Secret',
    SECRET_TOOLTIP: 'Value is masked in inputs and logs',
    SECRET_SAVED_PLACEHOLDER: 'Leave empty to use the saved secret',
    NAME_REQUIRED: 'Name is required',
    BACKUP_CREATED: 'Backup created',
    DOWNLOADING_BACKUP: 'Downloading backup',
    BACKUP_RESTORED: 'Backup restored',
    BACKUP_SEARCH_FAILED: 'Failed to load backups. Please try again.',
    UPLOAD_BACKUP: 'Upload backup',
    UPLOADING: 'Uploading',
    SHOW_UPLOADED: 'Show uploaded',
    INITIATED_BY: 'Initiated by',
    SAVE_AS_IMAGE: 'Save as image',
    CREATING_AND_SAVING_IMAGE: 'Creating image and saving to files...',
    IMAGE_SAVED: 'Image saved!',
    FAILED_TO_SAVE_IMAGE: 'Failed to save image.',
    GOAL_VALUE: 'Goal value',
    CURRENT_VALUE: 'Current value',
    PERCENTAGE_MET: '{percentage}% met',
    UNFREEZE_CELLS: 'Unfreeze values',
    FREEZE_CELLS: 'Freeze values',
    UNSET_GOAL: 'Unset value as goal',
    SET_GOAL: 'Set value as goal',
    INSPECT_VALUE: 'Inspect value',
    EDITING_TILE: 'Editing tile',
    NO_TILE_SELECTED: 'Please select a tile.',
    NO_TILE_OPTIONS: 'No options available.',
    TILE_NAME: 'Tile name',
    ENTER_TILE_NAME: 'Enter tile name',
    USE_FILTERS_FROM: 'Use filters from',
    USE_SORT_FROM: 'Use sort from',
    USE_TIMELINE_FROM: 'Use timeline from',
    SHOW_TILE_SORT: 'Show this tile’s sort',
    SHOW_TILE_FILTERS: 'Show this tile’s filters',
    SHOW_TILE_TIMELINE: 'Show this tile’s timeline',
    DASHBOARD: 'Dashboard',
    TILE: 'Tile',
    TILE_COPIED: 'Tile copied!',
    CHART_COLUMN_OPTIONS: 'Column options',
    CHART_ROW_OPTIONS: 'Row options',
    GENERAL_STYLING: 'General styling',
    PER_ROW_STYLING: 'Per row styling',
    PER_COLUMN_STYLING: 'Per column styling',
    TEXT_STYLE: 'Text style',
    ROW_STYLE: 'Row style',
    COLOR: 'Color',
    PALETTE: 'Palette',
    BACKGROUND: 'Background',
    BORDER: 'Border',
    SHADOW: 'Shadow',
    TOP_BORDER: 'Top border',
    BOTTOM_BORDER: 'Bottom border',
    INNER_BORDER: 'Inner border',
    RESET_GENERAL_STYLES: 'Reset general styles',
    RESET_ALL_PER_ROW_STYLES: 'Reset all per-row styles',
    RESET_ALL_PER_COLUMN_STYLES: 'Reset all per-column styles',
    RESET_STYLES: 'Reset styles',
    ADD_TABLE: 'New dimension table',
    ADD_VARIABLE: 'New variable',
    ADD_SHEET: 'New sheet',
    ADD_DASHBOARD: 'New dashboard',
    ADD_APP: 'New app',
    ADD_FILE: 'New file',
    ADD_FOLDER: 'New folder',
    ENABLED: 'Enabled',
    NEW_TEMPLATE: 'New template',
    EDIT_TEMPLATE: 'Edit template',
    SAVE_SELECTION_AS_TEMPLATE: 'Save selection as template',
    TEMPLATE_CREATED: 'Template created',
    TEMPLATE_UPDATED: 'Template updated',
    TEMPLATE_DELETED: 'Template deleted',
    TEMPLATE_NAME: 'Template name',
    TEMPLATE_DESCRIPTION: 'Template description',
    QUANTITY: 'Quantity',
    ENTER_TEXT: 'Enter text',
    ENTER_NAME: 'Enter name',
    ENTER_DESCRIPTION: 'Enter description',
    ENTER_NUMBER: 'Enter number',
    PICK_A_DATE: 'Pick a date',
    ERROR_CREATING_DIMENSION: 'Error while creating new dimension',
    ALLOW_MULTI_CREATE: 'Allow creating multiple items at once',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Set name, description and connections on create',
    ALLOW_PROPERTIES_ON_CREATE: 'Set properties on create',
    NAMING_CONFIG_ENABLED: '(Naming config enabled)',
    DIMENSION_TABLE: 'Dimension table',
    DIMENSION_TABLES: 'Dimension tables',
    DIMENSION_MEMBER: 'Dimension member',
    DIMENSION_MEMBERS: 'Dimension members',
    ASK_WHEN_CREATING: 'Ask when creating',
    PREDEFINED_CONNECTIONS: 'Predefined connections',
    REQUIRED: 'Required',
    CHOOSE_A_TABLE_FIRST: 'Choose a dimension table to set the connections for this template.',
    BIND_TO_TIMELINE: 'Bind to timeline',
    NEW_VARIABLE_COLUMN: 'New variable column',
    NEW_DIMENSION_COLUMN: 'New dimension column',
    NEW_LOOKUP_COLUMN: 'New lookup column',
    NEW_COMPARISON_COLUMN: 'New comparison column',
    EDITING_CUSTOM_COLUMN: 'Editing custom column',
    LOOKUP_PROPERTIES: 'Lookup properties',
    CALCULATION_COLUMN: 'Calculation column',
    ADD_COLUMNS: 'Add columns',
    COLUMN_NAME: 'Column name',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Are you sure you want delete this column?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Leave blank for an autogenerated name',
    NOTE_INSPECT_VALUE:
        'Note: The Inspect value feature displays only up to 500 rows. To view all data, please export the full dataset.',
    COPY_FROM: 'Copy from',
    COPY_FROM_TAGNAME: 'Copy from {tag}',
    PREVIEW: 'Preview',
    DECIMALS: 'Decimals',
    SIGNS: 'Signs',
    NEGATIVE_SIGNS: {
        SIGNED: 'Minus',
        UNSIGNED: 'Parentheses',
        EXPLICIT: 'Plus/Minus',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Positive',
        NEGATIVE: 'Negative',
    },
    BASE_UNIT: 'Base unit',
    BASE_UNITS: {
        ONES: 'Ones',
        THOUSANDS: 'Thousands',
        THOUSANDS_K: 'Thousands (k)',
        MILLIONS: 'Millions',
        MILLIONS_M: 'Millions (m)',
        BILLIONS: 'Billions',
        BILLIONS_B: 'Billions (b)',
        AUTO: 'Auto',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'January',
        February: 'February',
        March: 'March',
        April: 'April',
        May: 'May',
        June: 'June',
        July: 'July',
        August: 'August',
        September: 'September',
        October: 'October',
        November: 'November',
        December: 'December',
    },
    MONTHS_SHORT: {
        Jan: 'Jan',
        Feb: 'Feb',
        Mar: 'Mar',
        Apr: 'Apr',
        May: 'May',
        Jun: 'Jun',
        Jul: 'Jul',
        Aug: 'Aug',
        Sep: 'Sep',
        Oct: 'Oct',
        Nov: 'Nov',
        Dec: 'Dec',
    },
    DAYS: {
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
    },
    DAYS_SHORT: {
        Sun: 'Sun',
        Mon: 'Mon',
        Tue: 'Tue',
        Wed: 'Wed',
        Thu: 'Thu',
        Fri: 'Fri',
        Sat: 'Sat',
    },
    CURRENCY: 'Currency',
    SIGNING_IN: 'Signing in...',
    NEW_RELATION_COLUMN: 'New relation column',
    SELECT_TABLE_LOOKUP: 'Select table to lookup from',
    SELECT_TABLE_RELATION: 'Relate row members to',
    SELECT_TABLE_PROPERTY: 'Select property from table',
    DISPLAY_TABLE_PROPERTY: 'Display property from table',
    FILTER_MEMBERS: 'Filter member selection with sheet filters',
    TABLE_RELATION: 'Table relation',
    FILTER_DISPLAY: 'Filter display',
    RELATE_TABLE: 'Relate to table',
    USE_BLANKS: 'Use blanks',
    NO_DATA_TO_DISPLAY: 'No data to display',
    USE_REFERENCE_SORT: 'Use its sort',
    USE_REFERENCE_FILTERS: 'Use its filters',
    USE_REFERENCE_TIMELINE: 'Use its timeline',
    USE_REFERENCE_TEMPLATES: 'Use its templates',
    USE_REFERENCE_ROWS: 'Use its rows',
    USE_REFERENCE_COLUMNS: 'Use its columns',
    REFERENCE_ANOTHER_SHEET: 'Reference another sheet',
    NO_SHEET_SELECTED: 'No sheet selected',
    SELECT_SHEET: 'Select sheet',
    SHEET_REFERENCED: 'Sheet successfully referenced',
    CANNOT_ADD_ROWS: 'Cannot add rows while referenced',
    CANNOT_EDIT_ROWS: 'Cannot edit rows while referenced',
    CANNOT_EDIT_COLUMNS: 'Cannot edit columns while referenced',
    CANNOT_ADD_COLUMNS: 'Cannot add columns while referenced',
    CANNOT_ADD_FILTERS: 'Cannot add filters while referenced',
    REVERSE_DIMENSION: 'reverse connected dimension',
    REMOVE_FROM_RULE: 'Remove from rule',
    NEW_RULE: 'New rule',
    DUPLICATE_RULE: 'Duplicate rule',
    REMOVE_RULE: 'Remove rule',
    ENABLE_RULE: 'Enable rule',
    DISABLE_RULE: 'Disable rule',
    RULE_DISABLED: 'Disabled',
    VARIABLE_LOCK_INFO_TITLE: `This variable will only use this rule.`,
    VARIABLE_LOCK_INFO_BODY: `Other rules will be overridden. To lock the entire variable, leave the dimension section empty.`,
    DELETED: 'Deleted',
    DONE: 'Done',
    CHOOSE_ITEMS_TO_EXPORT: 'Choose items to export',
    UPLOAD_MODEL_FILE: 'Upload your model file',
    NO_FILE_SELECTED: 'No file selected',
    BACK: 'Back',
    ALLOW_IMPORT_TO: 'Allow import to',
    FINISHED: 'Finished',
    IMPORT_PREVIEW: 'This is a preview of the changes the import would apply with the current setting.\n\nChanges:\n',
    IMPORT_FINISHED: 'Import finished.\n\nChanges:\n',
    LOADING_MODEL: 'Importing model from file...',
    CUSTOM_COLUMN: 'Custom column',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Expand the row and column toolbar',
    SEARCH_FOR_EXPRESSIONS: 'Search for functions, variables, dimensions…',
    NEW: 'New',
    SELECT_A_CELL: 'Select a cell that contains a value to view the formula',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Select a cell to edit rows',
    OR_COLUMNS: 'or columns',
    MANAGE_PERMISSIONS_FOR: 'Manage permissions for "{name}"',
    VIEW_ONLY: 'View only',
    DATA_EDIT: 'Data edit',
    EDIT_OWNED: 'Edit owned',
    FULL_EDIT: 'Full edit',
    UNKNOWN_USER: 'Unknown user',
    UNKNOWN_GROUP: 'Unknown group',
    BUTTON_STYLE: 'Button style',
    BUTTON_STYLES: {
        primary: 'Primary',
        secondary: 'Secondary',
        tertiary: 'Tertiary',
        quaternary: 'Quaternary',
    },
    APP_ICON: 'App icon',
    LAST_MODIFIED_BY: 'Last modified by {name:string}',
    LAST_MODIFIED_BY_COLUMN: 'Last modified by',
    LAST_MODIFIED_AT_COLUMN: 'Last modified at',
    SHOW: 'Show',
    FORMULA_QA: 'Formula QA',
    TIME_LIMIT: 'Time limit',
    RESTRICTIONS: 'Restrictions',
    SEARCH_FOR_USERS_GROUPS: 'Search for users or groups…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Search or share with users, groups, or publicly…',
    STATUS_TRACKING: 'Status tracking',
    STATUS_TRACKING_MESSAGE: 'Tracking lets the user or group submit their changes and request your approval.',
    TRACK_STATUS: 'Track status',
    STOP_TRACKING: 'Stop tracking',
    RESTART_TRACKING: 'Restart tracking',
    ALL: 'All',
    TRACKED: 'Tracked',
    UNTRACKED: 'Untracked',
    ALL_TRACKED: 'All tracked',
    MY_TRACKED: 'My tracked',
    MY_APPROVALS: 'My approvals',
    ALL_SHARES: 'All shares',
    SUPER_USERS: 'Super users',
    LOADING_SUPER_USERS: 'Loading super users...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Cannot edit when time limit is active',
    CANNOT_EDIT_WHEN_TRACKED: 'Cannot edit when status is tracked',
    EXPORT_SHARES: 'Export shares',
    SHARE_COPIED: 'Share copied!',
    SHARES_COPIED: 'Shares copied!',
    COPY_SHARE_IN_FOLDER: 'Copy to everything in this folder',
    COPY_AND_OVERRIDE_SHARES: 'Copy and override shares',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION:
        'All existing shares on items and folders inside this one will be replaced with the current folder’s shares.',
    COPY_ALL_SHARES_IN_FOLDER: 'Copy and override all shares in this folder',
    GRID_SINGLE_CHART_EXPLANATION: 'Single chart with top-level rows',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Grid of small charts, one for each top-level row',
    DUPLICATE_KEYS_FOUND: 'Duplicate keys found',
    DUPLICATE_KEYS_PROMPT: 'Do you want to filter out and only create the unique items?',
    NAMES_SHOULD_BE_UNIQUE: 'Names should be unique',
    LIMIT_TO_FILTERED_OPTIONS: 'Limit to filtered options',

    // Toast messages
    SWITCHING_TENANT: 'Switching workspace',
    TENANT_SWITCHED_SUCCESS: 'Workspace switched successfully',
    TENANT_SWITCH_FAILED: 'Failed to fetch new workspace data. Please refresh the page',
    FAILED_LOAD_MESSAGES: 'Failed to load messages',
    NEW_CHAT_CREATED: 'New chat created!',
    FAILED_LOAD_CHATS: 'Failed to load chats.',
    FAILED_CREATE_CHAT: 'Failed to create a new chat.',
    FAILED_SEND_MESSAGE: 'Failed to create a new chat or send the message.',
    FAILED_RENAME_CHAT: 'Failed to rename the chat.',
    FAILED_DELETE_CHAT: 'Failed to delete a chat.',
    XLSX_FILE_ONLY: '.xlsx file only',
    JSON_FILE_ONLY: '.json file only',
    EXPORT_DONE: 'Done!',
    LOCKS_SAVED: 'Locks saved',
    COPIED_TO_CLIPBOARD: 'Copied to clipboard',
    INVALID_INTERVAL: 'Invalid interval',
    SELECT_REQUIRED_DIMENSIONS: 'Select required dimensions.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Entity type not specified',

    // Button labels
    OK: 'OK',
    DELETE_ENTITY: 'Delete entity',
    SAVE_ENTITY: 'Save entity',
    GENERATED_ENTITIES: 'Generated entities',
    NEW_ENTITY: 'New entity',
    ENTITIES: 'Entities',
    SHOW_LOGS: 'Show logs',
    CALCULATE: 'Calculate',
    FORMULA_QA_TITLE: 'Formula QA',
    RENAME_CHAT: 'Rename chat',
    SEND: 'Send',
    EXPORT_CURRENT_SHEET: 'Export current sheet',
    TERMINATE: 'Terminate',
    CONFIRM_UPDATE: 'Confirm update',

    // Form labels and placeholders
    FROM_DATE: 'From date',
    TO_DATE: 'To date',
    AUDIT_TYPE: 'Audit type',
    SELECT_AUDIT_TYPE: 'Select audit type',
    USER: 'User',
    PAGE_SIZE: 'Page size',
    SELECT_PAGE_SIZE: 'Select page size',
    SELECT_USER: 'Select user',
    EXPORT_EXPANDED_ROWS: 'Export currently expanded rows',
    EXPORT_ALL_ROWS: 'Export all rows',
    EXPORT_FILENAME_LABEL: 'Name',
    EXPORT_VARIABLE: 'Export variable',
    EXPORT_FORMAT: 'Export format',
    EXPORT_FORMAT_XLSX: '.xlsx (Excel 2007 and above)',
    EXPORT_FORMAT_CSV_BOM: '.csv (Excel compatible)',
    EXPORT_FORMAT_CSV: '.csv (pure data)',
    EXPORT_FORMAT_JSON: '.json',
    INCLUDE_MEMBERS: 'Include members',
    MESSAGE_FARSEER_AI: 'Message FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Enter new chat name',
    FLAG: 'Flag',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Give me a brief summary of the model',
    CHAT_SUGGESTION_DIMENSIONS:
        'Are there any variables that have more dimensions than the variables used in its formula?',
    CHAT_SUGGESTION_DELAY: 'Do any variables use the delay() function?',
    CHAT_SUGGESTION_ONDEMAND: 'List all on-demand variables',
    CHAT_SUGGESTION_MEASURES: 'List all measures',
    CHAT_SUGGESTION_FIXED: 'List all variables that use a fixed dimension',
    CHAT_SUGGESTION_DATE: 'List all dimensions that have a date property',

    // Loading defaults
    DEFAULT_LOADING: 'Loading...',
    DEFAULT_SUCCESS: 'Success!',

    // Audit logs
    TOTAL_RESULTS: 'Total results: {count:number}',
    PAGE_OF_TOTAL: 'Page {current:number} of {total:number}',
    DB_ID: 'DB ID',
    DATE_AND_TIME: 'Date and Time',
    LOG_TYPE: 'Log type',
    DATA: 'Data',

    // Entity debugger
    NO_TYPES: 'No types',

    // Formula QA Modal
    RESULT: 'Result: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Enter a formula to calculate the result.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Exporting selected model items...',

    // Search
    RECENTLY_SEARCHED: 'Recently searched',

    // Compound formulas
    UNPARSEABLE_COMPOUND_FORMULA: 'This formula is too complex to be represented as compound rules',

    // Datasets
    DATASET_CURRENT_VERSION: 'Current version',
    DATASET_NOT_CURRENT_VERSION: 'Not the current version',
    DATASET_ROW_COUNT: '{rows:string} {{count:row|rows}}',
    DATASET_ROWS_WRITTEN: 'Rows written',
    DATASET_SIZE_WRITTEN: 'Size written',
    DATASET_ROW_COUNT_PREVIEW_LIMITED: '{rows:string} rows, first {shown:string} shown',
    DATASET_PREVIEW_UNSUPPORTED_FORMAT: 'The preview reads parquet and CSV versions. Download this version to open it.',
    DATASET_PREVIEW_TOO_LARGE: 'This version is too large to preview. Download it to open it.',
    DATASET_WRITTEN_BY: 'Written by',
    DATASET_OPENED_FROM: 'Opened from',
    DATASET_FROM_OPENED_RUN: 'Written by the opened run',
    DATASET_SHOW_CURRENT: 'Show current',
    DATASET_VERSION_CANCELLED: 'This version was cancelled and never became current.',
    DATASET_VERSION_CANCELLED_EMPTY: 'This version was cancelled and never became current. It holds no data.',
    DATASET_VERSION_STILL_WRITING: 'This version is still being written. It has no data to preview yet.',
    DATASET_PREVIEW_FIRST_FILE: 'This version has {count:number} files. Only {filename:string} is shown.',
    DATASET_NO_PUBLISHED_VERSION: 'No data yet. This dataset has no published version.',
    DATASET_VERSION_NOT_FOUND: 'This version no longer exists.',
    DATASET_PREVIEW_FORBIDDEN: 'You do not have permission to read this dataset.',
    DATASET_COPY_LOADED_ROWS_ONLY: 'Only the rows already shown were copied. Download the file to get every row.',
    DATASET_NOT_FOUND: 'Dataset not found or not accessible.',
    GO_BACK_TO_DATASETS: 'Go back to datasets',
    OPEN_DATASET: 'Open dataset',
    OPEN_DATASET_VERSION: 'Open this version',
    DATASETS_LOAD_FAILED: 'Failed to load datasets',
    PIPELINES_LOAD_FAILED: 'Failed to load pipelines',
    PIPELINES_NO_PERMISSION: "You need the '{permission:string}' permission to list pipelines.",
    DATASET_DELETE_CONFIRM: 'Delete dataset {name:string}? This removes all its versions and cannot be undone.',
    DATASET_VERSION_HISTORY: 'Version history',
    DATASET_VERSION_COUNT: '{count:number} {{version|versions}}',
    DATASET_VERSIONS_LOAD_FAILED: 'Failed to load versions',
    DATASET_VERSION_STARTED: 'Started',
    DATASET_VERSION_PUBLISHED: 'Published',
    DATASET_VERSION_STATUS_MAP: {
        current: 'Current',
        published: 'Published',
        candidate: 'Completed, not published',
        writing: 'Writing',
    },
    DATASET_VERSION_CANCELLATION_MAP: {
        manual: 'Cancelled',
        run_closed: 'Run ended before publishing',
        run_failed: 'Run failed',
        validation_failed: 'Failed validation',
        superseded_by_retry: 'Replaced by a newer run',
        publication_conflict: 'Not published: the current version changed during the run',
        expired: 'Not published within 24 h',
        legacy_cancelled: 'Cancelled (before history tracking)',
    },
    DATASET_VERSION_PUBLICATION_CONFLICT: 'Not published: {version:string} became current during the run',
    DATASET_MAKE_CURRENT: 'Make current',
    DATASET_MAKE_CURRENT_TITLE: 'Make {version:string} current?',
    DATASET_MAKE_CURRENT_QUESTION:
        'From now on, Load steps, other pipelines and the preview read {version:string} of {dataset:string}. Data already loaded into a model does not change.',
    DATASET_MAKE_CURRENT_WARNING:
        'If a run is writing this dataset now, it fails. A saved reading position moves back to {version:string}.',
    DATASET_MAKE_CURRENT_NO_PERMISSION: "You need the '{permission:string}' permission to change the current version.",
    DATASET_PUBLISH: 'Publish',
    DATASET_PUBLISH_TITLE: 'Publish {version:string}?',
    DATASET_PUBLISH_QUESTION:
        'Publishing makes {version:string} the current version. Its pipeline run did not publish it: the run stopped early, or it is still running.',
    DATASET_PUBLISH_WARNING: 'Publishing skips the checks that the run makes before it publishes.',
};

export default { ...translationValues };
